export default [
  {
    title: 'Agencies',
    icon: 'agency.svg',
    customIcon: true,
    children: [
      {
        title: 'Agents',
        route: 'agency-agents-index',
        icon: 'agents-black.svg',
        customIcon: true,
        resource: 'Agent',
        action: 'read',
        parent: 'agencies',
      },
      // {
      //   title: 'Agent Requests',
      //   route: 'agencies-agent-profile-update-index',
      //   icon: 'AlertCircleIcon',
      //   parent: 'agencies',
      //   resource: 'AgentRequest',
      //   action: 'read',
      // },
      {
        title: 'Reservations',
        key: 'Reservations',
        route: 'agencies-reservations-index',
        params: {
          type: 'reserved',
        },
        icon: 'PaperclipIcon',
        parent: 'agencies',
        resource: 'LotReservation',
        action: 'read',
      },
      // {
      //   title: 'Announcements',
      //   icon: 'MessageCircleIcon',
      //   parent: 'agencies',
      //   key: 'agencies announcement categories',
      //   children: [
      //     {
      //       title: 'Announcements',
      //       route: 'agencies-announcements-index',
      //       icon: '',
      //       params: {
      //         type: 'all-announcement',
      //       },
      //       resource: 'Announcement',
      //       action: 'read',
      //     },
      //     {
      //       title: 'Pending Verification',
      //       route: 'agencies-announcements-index',
      //       icon: '',
      //       params: {
      //         type: 'pending',
      //       },
      //       resource: 'Announcement',
      //       action: 'read',
      //     },
      //     {
      //       title: 'Announcement Categories',
      //       route: 'agencies-announcement-categories-index',
      //       icon: '',
      //       params: {
      //         type: 'all-announcement-category',
      //       },
      //       resource: 'AnnouncementCategory',
      //       action: 'read',
      //     },
      //   ],
      // },
      // {
      //   title: 'FAQ',
      //   icon: 'HelpCircleIcon',
      //   parent: 'agencies',
      //   key: 'agencies faq',
      //   children: [
      //     {
      //       title: 'Articles',
      //       route: 'agencies-articles-index',
      //       icon: '',
      //       params: {
      //         type: 'all-article',
      //       },
      //       resource: 'AgentArticle',
      //       action: 'read',
      //     },
      //     {
      //       title: 'Article Categories',
      //       route: 'agencies-article-categories-index',
      //       icon: '',
      //       params: {
      //         type: 'all-article-category',
      //       },
      //       resource: 'AgentArticleCategory',
      //       action: 'read',
      //     },
      //   ],
      // },
      {
        title: 'Settings',
        key: 'Reservation Settings',
        route: 'agencies-reservation-settings',
        icon: 'SettingsIcon',
        parent: 'agencies',
        resource: 'ReservationSetting',
        action: 'create',
      },
    ],
  },
]
